// extracted by mini-css-extract-plugin
export default {"settings-section":"styles_settings-section__NcYT4","matomo-link":"styles_matomo-link__bMJ1b","matomo-logo":"styles_matomo-logo__CLAV3"};